import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureDataAccessTranslationDictionary } from './feature-data-access-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureDataAccessTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      COVER_DETAILS_INCLUSION_BREAKDOWNS: 'Cover for breakdowns & faults',
      COVER_DETAILS_INCLUSION_ACCIDENTAL_DAMAGE: 'Accidental damage',
      COVER_DETAILS_INCLUSION_UNLIMITED_REPAIRS: 'Unlimited repairs',
      COVER_DETAILS_INCLUSION_REPLACEMENT:
        "Replacement with same or similar features, if it can't be fixed",
      COVER_DETAILS_EXCLUSION_DELIBERATE_DAMAGE:
        'Deliberate damage or cosmetic damage like scratches or dents',
      COVER_DETAILS_EXCLUSION_INSTALLATION_COSTS:
        'Costs for installing or removing a replaced appliance',
      COVER_DETAILS_ADDITIONAL_EXPERT_REPAIRS:
        'Repairs made by expert engineers',
      COVER_DETAILS_ADDITIONAL_ONLINE_BOOKING:
        'Easy online booking at any time',
      COVER_DETAILS_COVERED_IMMEDIATE_ACCIDENTAL_DAMAGE:
        'Immediate cover for accidental damage',
      COVER_DETAILS_COVERED_UNLIMITED_CALLOUTS:
        'Unlimited call-outs with no extra costs',
      COVER_DETAILS_COVERED_REPLACEMENT:
        "A replacement if it can't be fixed - with the same or similar features",
      COVER_DETAILS_COVERED_BREAKDOWN_AFTER_GUARANTEE:
        'Cover for breakdowns when your guarantee ends',
    },
    [LocaleId.English_Ireland]: {
      COVER_DETAILS_INCLUSION_BREAKDOWNS: 'Cover for breakdowns & faults',
      COVER_DETAILS_INCLUSION_ACCIDENTAL_DAMAGE: 'Accidental damage',
      COVER_DETAILS_INCLUSION_UNLIMITED_REPAIRS: 'Unlimited repairs',
      COVER_DETAILS_INCLUSION_REPLACEMENT:
        "Replacement with same or similar features, if it can't be fixed",
      COVER_DETAILS_EXCLUSION_DELIBERATE_DAMAGE:
        'Deliberate damage or cosmetic damage like scratches or dents',
      COVER_DETAILS_EXCLUSION_INSTALLATION_COSTS:
        'Costs for installing or removing a replaced appliance',
      COVER_DETAILS_ADDITIONAL_EXPERT_REPAIRS:
        'Repairs made by expert engineers',
      COVER_DETAILS_ADDITIONAL_ONLINE_BOOKING:
        'Easy online booking at any time',
      COVER_DETAILS_COVERED_IMMEDIATE_ACCIDENTAL_DAMAGE:
        'Immediate cover for accidental damage',
      COVER_DETAILS_COVERED_UNLIMITED_CALLOUTS:
        'Unlimited call-outs with no extra costs',
      COVER_DETAILS_COVERED_REPLACEMENT:
        "A replacement if it can't be fixed - with the same or similar features",
      COVER_DETAILS_COVERED_BREAKDOWN_AFTER_GUARANTEE:
        'Cover for breakdowns when your guarantee ends',
    },
  };
